(() => {
	const TRIGGER = 'button[interestfor^="card-member-modal-"]';
	const POPOVER = "[data-product-card-member-modal]";
	const CLOSE_BUTTON = "[data-product-card-member-modal-close]";
	const MOBILE_SHEET = window.matchMedia("(max-width: 767px) and (not (hover: hover))");
	const CLOSE_MS = 300;

	const isMobileSheet = () => MOBILE_SHEET.matches;

	const getPopover = (trigger) => {
		const id =
			trigger.getAttribute("interestfor") ||
			trigger.getAttribute("popovertarget");
		return id ? document.getElementById(id) : null;
	};

	const getTrigger = (popover) => {
		if (!popover?.id) return null;
		return document.querySelector(
			`[interestfor="${popover.id}"], [popovertarget="${popover.id}"]`
		);
	};

	const animateClose = (popover) => {
		if (!popover?.hidePopover || !popover.matches(":popover-open")) return;

		if (!isMobileSheet()) {
			popover.hidePopover();
			return;
		}

		popover.classList.add("is-closing");

		let closed = false;
		const finish = () => {
			if (closed) return;
			closed = true;
			popover.classList.remove("is-closing");
			if (popover.matches(":popover-open")) popover.hidePopover();
		};

		const onTransitionEnd = (event) => {
			if (event.target !== popover || event.propertyName !== "transform") return;
			popover.removeEventListener("transitionend", onTransitionEnd);
			finish();
		};

		popover.addEventListener("transitionend", onTransitionEnd);
		window.setTimeout(finish, CLOSE_MS + 50);
	};

	document.addEventListener(
		"pointerdown",
		(event) => {
			if (!isMobileSheet()) return;

			document.querySelectorAll(`${POPOVER}:popover-open`).forEach((popover) => {
				const trigger = getTrigger(popover);
				if (popover.contains(event.target) || trigger?.contains(event.target)) {
					return;
				}
				animateClose(popover);
			});
		},
		true
	);

	document.addEventListener(
		"click",
		(event) => {
			const closeButton = event.target.closest(CLOSE_BUTTON);
			if (closeButton) {
				const popover = closeButton.closest(POPOVER);
				if (!popover?.matches(":popover-open")) return;

				event.preventDefault();
				event.stopImmediatePropagation();
				animateClose(popover);
				return;
			}

			if (!isMobileSheet()) return;

			const trigger = event.target.closest(TRIGGER);
			if (!trigger) return;

			const popover = getPopover(trigger);
			if (!popover?.matches(":popover-open")) return;

			event.preventDefault();
			event.stopImmediatePropagation();
			animateClose(popover);
		},
		true
	);

	document.addEventListener("toggle", (event) => {
		const popover = event.target;
		if (!popover?.matches?.(POPOVER) || !isMobileSheet()) return;
		if (event.newState === "open") popover.classList.remove("is-closing");
	});

	window.addEventListener("cart:added", () => {
		document.querySelectorAll(`${POPOVER}:popover-open`).forEach(animateClose);
	});
})();
